import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CrisisResources = () => {
  const emergencyContacts = [
    {
      id: 1,
      name: "Suicide & Crisis Lifeline",
      description: "24/7 free and confidential support for people in distress",
      phone: "131114",
      icon: "Phone",
      type: "call"
    },
    {
      id: 2,
      name: "Crisis Text Line",
      description: "Text HOME to 741741 for 24/7 crisis support via text",
      phone: "741741",
      icon: "MessageCircle",
      type: "text"
    },
    {
      id: 3,
      name: "SAMHSA National Helpline",
      description: "Treatment referral and information service",
      phone: "1-800-662-4357",
      icon: "Headphones",
      type: "call"
    },
    {
      id: 4,
      name: "Veterans Crisis Line",
      description: "Support for veterans and their families",
      phone: "988 (Press 1)",
      icon: "Shield",
      type: "call"
    }
  ];

  const handleEmergencyCall = (phone) => {
    const cleanPhone = phone?.replace(/[^0-9]/g, '');
    window.location.href = `tel:${cleanPhone}`;
  };

  return (
    <section id="crisis-resources" className="bg-error/5 border-t-4 border-error py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-error/10 rounded-full mb-4">
            <Icon name="AlertCircle" size={32} className="text-error" />
          </div>
          <h2 className="text-3xl font-bold text-foreground mb-3">
            Immediate Crisis Support Available
          </h2>
          <p className="text-lg text-muted-foreground">
            If you're experiencing a mental health emergency, help is available right now
          </p>
        </div>

        <div className="bg-card rounded-xl border border-border p-6 mb-8">
          <div className="flex items-start gap-4 mb-6">
            <div className="bg-error/10 rounded-lg p-3 flex-shrink-0">
              <Icon name="AlertTriangle" size={24} className="text-error" />
            </div>
            <div>
              <h3 className="font-semibold text-foreground mb-2">
                When to Seek Emergency Help
              </h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li className="flex items-start gap-2">
                  <Icon name="Dot" size={20} className="text-error flex-shrink-0 mt-0.5" />
                  <span>Thoughts of harming yourself or others</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Dot" size={20} className="text-error flex-shrink-0 mt-0.5" />
                  <span>Severe anxiety, panic attacks, or overwhelming distress</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Dot" size={20} className="text-error flex-shrink-0 mt-0.5" />
                  <span>Substance abuse crisis or withdrawal symptoms</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Dot" size={20} className="text-error flex-shrink-0 mt-0.5" />
                  <span>Psychotic symptoms or loss of touch with reality</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-error/5 rounded-lg p-4 border border-error/20">
            <p className="text-sm font-medium text-foreground mb-2">
              <Icon name="Info" size={16} className="inline mr-2 text-error" />
              For life-threatening emergencies, call 911 immediately
            </p>
            <p className="text-xs text-muted-foreground">
              Emergency services can provide immediate medical intervention and transport to appropriate facilities
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {emergencyContacts?.map((contact) => (
            <div
              key={contact?.id}
              className="bg-card rounded-lg border border-border p-5 hover:shadow-md transition-shadow duration-200"
            >
              <div className="flex items-start gap-4">
                <div className="bg-primary/10 rounded-lg p-3 flex-shrink-0">
                  <Icon name={contact?.icon} size={24} className="text-primary" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-foreground mb-1">
                    {contact?.name}
                  </h3>
                  <p className="text-sm text-muted-foreground mb-3">
                    {contact?.description}
                  </p>
                  <Button
                    variant="outline"
                    size="sm"
                    iconName={contact?.type === 'call' ? 'Phone' : 'MessageSquare'}
                    iconPosition="left"
                    onClick={() => handleEmergencyCall(contact?.phone)}
                    className="w-full"
                  >
                    {contact?.phone}
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-muted-foreground">
            All crisis services are free, confidential, and available 24/7 • No authentication required
          </p>
        </div>
      </div>
    </section>
  );
};

export default CrisisResources;